// src/modules/components/HeaderCADPro/index.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  HeaderContainer,
  HeaderContent,
  Logo,
  Navigation,
  NavLink,
  AuthButtons,
  ContactButton,
  MobileMenuButton,
  MobileMenu,
  MobileNavItem,
  MobileContactArea
} from './styles';

import { 
  FaBars,
  FaTimes,
  FaEnvelope,
  FaArrowRight
} from 'react-icons/fa';

import logoCADPro from '../../../assets/logoCADPro.svg';

export const HeaderCADPro = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Função para abrir o modal de contato via evento customizado
  const handleOpenContactModal = (e) => {
    e.preventDefault();
    closeMobileMenu();
    // Dispara evento customizado que será capturado pelo EngenhariaAplicada
    window.dispatchEvent(new CustomEvent('openContactModal'));
  };

  return (
    <HeaderContainer isScrolled={isScrolled}>
      <HeaderContent>
        <Logo to="/" onClick={() => { closeMobileMenu(); window.scrollTo(0, 0); }}>
          <img src={logoCADPro} alt="CADPro Engenharia Aplicada" />
        </Logo>

        <Navigation>
          <NavLink href="#servicos">Serviços</NavLink>
          <NavLink href="#depoimentos">Depoimentos</NavLink>
          <NavLink href="#contato">Contato</NavLink>
        </Navigation>

        <AuthButtons>
          <ContactButton href="#" onClick={handleOpenContactModal}>
            <FaEnvelope />
            Solicitar Orçamento
          </ContactButton>
        </AuthButtons>

        <MobileMenuButton onClick={toggleMobileMenu} aria-label="Menu">
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </MobileMenuButton>
      </HeaderContent>

      <MobileMenu isOpen={isMobileMenuOpen}>
        <MobileNavItem href="#servicos" onClick={closeMobileMenu}>
          Serviços
          <FaArrowRight />
        </MobileNavItem>
        <MobileNavItem href="#depoimentos" onClick={closeMobileMenu}>
          Depoimentos
          <FaArrowRight />
        </MobileNavItem>
        <MobileNavItem href="#contato" onClick={closeMobileMenu}>
          Contato
          <FaArrowRight />
        </MobileNavItem>
        
        <MobileContactArea>
          <ContactButton href="#" onClick={handleOpenContactModal}>
            <FaEnvelope />
            Solicitar Orçamento
          </ContactButton>
        </MobileContactArea>
      </MobileMenu>
    </HeaderContainer>
  );
};

export default HeaderCADPro;